import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DomSanitizer} from '@angular/platform-browser';
import { Service } from '../../app/service';
import { ThemenSelector } from '../thema/thema';
import { Settings } from '../settings/settings';

@Component({
  selector: 'page-question',
  templateUrl: 'question.html'
})

export class Question {

  level: number;
  topic: number;
  mode: any;
  questions: any;

  frage: any;
  antwort: any;
  thema: any;
  bild_frage: any;
  bild_antwort: any;
  bild_frage_vis: any;
  bild_antwort_vis: any;
  antwort_vis: any;
  button_icon: any;
  modeHeader: string;
  link_vis: any;
  url_vis: any;
  videotext: any;
  url: any;
  videoid: any;
  videolink: any;
  marginbottom: any;

  count: number;
  topicList: any = [];

  constructor(public navCtrl: NavController, private navParams: NavParams, private DataProvider: Service, private sanitizer: DomSanitizer) {
    //get datat handled over by navigation
    this.level = navParams.get('level');
    this.topic = navParams.get('topic');
    this.mode = navParams.get('mode');

    console.log("open Questions", this.mode, this.level, this.topic);

    //set mode header
    if(this.mode == "lernen")
      this.modeHeader = "Lernmodus";
    else
      this.modeHeader = "Prüfungsmodus";

    //get topic names
    this.topicList = [];
    this.topicList = DataProvider.getTopicNames();
    console.log("topic list", this.topicList);

    //get Questions by level and topic
    this.questions = DataProvider.getQuestions(this.level, this.topic, this.mode);

    //if prüfungsmode hide answer
    this.antwort_vis = this.mode == "pruefen";
    if(!this.antwort_vis)  //shown
      this.button_icon = "arrow-forward";
    else
      this.button_icon = "checkmark";

    //set first quest and answer
    this.count = 0;
    this.setGUI(0);
  }

  getSettingsReplacedAnswer(_question: any) {
    var ids = this.DataProvider.getSettingsIDs();
    var settings = this.DataProvider.getSettingsData();
    console.log("ids", ids);
    for(var i=0; i<ids.length; i++)
    {
      if(_question._id == ids[i].s1)
      {
        if(settings[i])
          _question.antwort = _question.antwort.replace("*EINSTELLUNGEN*", settings[i]);
        else
          this.DataProvider.showPopup("Einstellungen", "Bitte in den Einstellungen die Antworten einsetzen!", "Öffnen", "Abbrechen", this, function(ref, button){
              if(button)  //clicked open settings
                ref.openSettings();
          });
      }

      if(_question._id == ids[i].s2)
      {
        if(settings[i])
          _question.antwort = _question.antwort.replace("*EINSTELLUNGEN2*", settings[i]);
      }
    }

    //nothing to replace
    return _question.antwort;
  }

  openSettings() {
    this.navCtrl.push(Settings, {data: 0});
  };

  setGUI(_index: number) {
    this.thema = this.topicList[this.questions[_index].thema-1];
    this.frage = this.questions[_index].frage
    //this.antwort = this.questions[_index].antwort;
    this.antwort = this.getSettingsReplacedAnswer(this.questions[_index]);;
    this.bild_frage = "assets\\img\\" + this.questions[_index].image_frage + ".png";
    this.bild_antwort = "assets\\img\\" + this.questions[_index].image_antwort + ".png";
    this.bild_frage_vis = this.questions[_index].image_frage == "nix";
    this.bild_antwort_vis = this.questions[_index].image_antwort == "nix";
    this.url_vis = this.questions[_index].linktext == "nix";
    this.videotext = this.questions[_index].linktext;
    this.url = this.questions[_index].url;
    this.link_vis = this.antwort_vis || this.url_vis;
    this.videoid = "https://www.youtube.com/embed/" + this.questions[_index].yt_id;
    this.videolink = this.sanitize(this.videoid);

    //add margin for quests with no videoid
    if(this.link_vis)
      this.marginbottom = this.sanitizer.bypassSecurityTrustStyle("margin-bottom: 7rem");
    else
      this.marginbottom = this.sanitizer.bypassSecurityTrustStyle("margin-bottom: 10px");

    console.log("margin-bottom", this.marginbottom);
  }

  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  nextQuestion() {
    if(!this.antwort_vis) //answer is hidden
    {
      if(this.mode == "pruefen")  //hide answer and show other button
      {
        //check button
        this.button_icon = "checkmark";
        this.antwort_vis = true;
      }

      if(++this.count < this.questions.length)
      {
          this.setGUI(this.count);
      }
      else
      {
        //finish topic - open selector
        //this.navCtrl.push(ThemenSelector, {mode: this.mode, level: this.level});
        this.navCtrl.pop();
        console.log("finish topic, open selector", this.level);
      }
    }
    else  //show answer
    {
      //next button
      this.button_icon = "arrow-forward";
      this.antwort_vis = false;
    }
    this.link_vis = this.antwort_vis || this.url_vis;
  }

  lastQuestion() {
    if(this.antwort_vis) //answer is hidden
    {
      if(this.mode == "pruefen")  //hide answer and show other button
      {
        //check button
        this.button_icon = "arrow-forward";
        this.antwort_vis = false;
      }

      if(--this.count >= 0)
      {
          this.setGUI(this.count);
      }
      else
      {
        //finish topic - open selector
        //this.navCtrl.push(ThemenSelector, {mode: this.mode, level: this.level});
        this.navCtrl.pop();
        console.log("finish topic, open selector", this.level);
      }
    }
    else  //show answer
    {
      if(this.mode == "pruefen")
      {
        //next button
        this.button_icon = "checkmark";
        this.antwort_vis = true;
      }
      else
      {
        this.button_icon = "arrow-forward";
        this.antwort_vis = false;

        if(--this.count >= 0)
        {
            this.setGUI(this.count);
        }
        else
        {
          //finish topic - open selector
          //this.navCtrl.push(ThemenSelector, {mode: this.mode, level: this.level});
          this.navCtrl.pop();
          console.log("finish topic, open selector", this.level);
        }
      }
    }
    this.link_vis = this.antwort_vis || this.url_vis;
  }

  openVideolink() {
    this.DataProvider.openInBrowser(this.url);
  }
}



// WEBPACK FOOTER //
// ./src/pages/question/question.ts